import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Benefits from "@/components/Benefits";
import HowItWorks from "@/components/HowItWorks";
import Pricing from "@/components/Pricing";
import CaseStudies from "@/components/CaseStudies";
import Testimonials from "@/components/Testimonials";
import WhyChooseUs from "@/components/WhyChooseUs";
import ConsultationForm from "@/components/ConsultationForm";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import WhatsAppChat from "@/components/WhatsAppChat";

const HomePage = () => (
  <>
    <Navbar />
    <Hero />
    <Services />
    <Benefits />
    <HowItWorks />
    <Pricing />
    <CaseStudies />
    <Testimonials />
    <WhyChooseUs />
    <ConsultationForm />
    <FAQ />
    <Footer />
    <WhatsAppChat />
    <Toaster position="top-right" richColors />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
